import { FunnelBar } from "./FunnelBar";
import { STAGES, FUNNEL_WIDTH_FLOOR } from "../constants";
import { parsePrimaryHSL } from "../utils/colors";

/**
 * Lista vertical de barras do funil. Recebe os stats brutos do backend e a
 * cor primária do tenant. Cada barra é uma instância de <FunnelBar />, com
 * largura derivada de `Math.max(piso, ratio_real)` pra manter decrescente
 * mesmo quando os últimos estágios têm ratios próximos.
 */
export function FunnelBars({ stats, primaryHSL }) {
  const hsl = parsePrimaryHSL(primaryHSL);

  return (
    <div className="bg-card rounded-2xl border shadow-sm p-4 md:p-6">
      <div className="space-y-3">
        {STAGES.map((stage, i) => {
          const count = stats?.current?.[stage.key] ?? 0;
          const prevCount = stats?.previous?.[stage.key] ?? 0;
          const delta = stats?.delta_pct?.[stage.key] ?? 0;
          const ratioCurrent = i === 0 ? 100 : (stats?.ratios_current?.[stage.key] ?? 0);
          const ratioPrevious = i === 0 ? 100 : (stats?.ratios_previous?.[stage.key] ?? 0);
          const width = Math.max(FUNNEL_WIDTH_FLOOR[i] ?? 45, ratioCurrent);
          const layerLightness = Math.max(20, hsl.l - i * 4);
          return (
            <FunnelBar
              key={stage.key}
              stage={stage}
              data={{ count, prevCount, delta, ratioCurrent, ratioPrevious }}
              style={{ width, hsl, layerLightness }}
            />
          );
        })}
      </div>
    </div>
  );
}
